import React from 'react';
import Content, { HTMLContent } from '../components/Content';
import Logo from '../components/logo/Logo'



export const ResumePageTemplate = ({ title, content, contentComponent, skills }) => {
  const PageContent = contentComponent || Content;
  return <section className="section page resume">
    <div className="container resume-heading">
      <div className="row justify-content-md-center">
        <div className="col-sm-3">
        <img src="/img/contact-thumbnail.jpg" className="rounded-circle img-thumbnail"/>
        </div>
        <div className="col-sm-6 align-self-center text-center title">
          <hr/>
          <Logo size="xl"/>
          <h1 className="subheading text-center">
            <small><i>CONTACT ME</i></small>
          </h1>
          <hr/>
        </div>
      </div>

      <div className="row contact-content animate fade-in">
        <PageContent className="content" content={content} />
      </div>
    </div>
  </section>;
}

export default ({ data }) => {
  const { markdownRemark: post } = data;
  return <ResumePageTemplate
    contentComponent={HTMLContent}
    title={post.frontmatter.title}
    content={post.html}
  />;
};

export const pageQuery = graphql`
  query ContactPage($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/contact-page.js